const confirmationMessage = (message, response) => {
    window.vm.$swal({
        title: message,
        showCancelButton: true,
        confirmButtonText: window.vm.$t('globalTrans.yes'),
        cancelButtonText: window.vm.$t('globalTrans.no'),
        focusConfirm: false
    }).then((result) => {
        response(result.isConfirmed)
    })
}

export default confirmationMessage
